import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const mockVirtualTours = [
  {
    id: "1",
    slug: "anitkabir",
    title: "Anıtkabir Sanal Turu",
    description:
      "Türkiye Cumhuriyeti'nin kurucusu Mustafa Kemal Atatürk'ün ebedi istirahatgahı olan Anıtkabir'i üç boyutlu sanal tur ile keşfedin.",
    embed: (
      <iframe
        src="https://www.google.com/maps/embed?pb=!4v1754555755513!6m8!1m7!1sd8CRxMrBL8WNR8kIO0020A!2m2!1d39.92562682548143!2d32.83626594968425!3f353.1733605753914!4f-15.73570376816862!5f0.7820865974627469"
        className="w-full h-full"
        loading="lazy"
        allow="accelerometer; gyroscope;"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
      />
    ),
    content: "Bu alanda Anıtkabir'in etkileşimli sanal turu yer alacaktır.",
  },
  {
    id: "2",
    slug: "hacibayram",
    title: "Hacı Bayram Veli Camii Sanal Turu",
    description:
      "Ankara'nın tarihi ve manevi merkezlerinden biri olan Hacı Bayram Veli Camii'nin atmosferini sanal turla deneyimleyin.",
    embed: (
      <iframe
        src="https://www.google.com/maps/embed?pb=!4v1754555695445!6m8!1m7!1sAFFkqwUIsN3BpX-APnNLQA!2m2!1d39.94448764457216!2d32.85862592335039!3f294.45850177770313!4f0!5f0.7820865974627469"
        className="w-full h-full"
        loading="lazy"
        allow="accelerometer; gyroscope;"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
      />
    ),
    content:
      "Bu alanda Hacı Bayram Veli Camii'nin etkileşimli sanal turu yer alacaktır.",
  },
  {
    id: "3",
    slug: "baskent-milletbahcesi",
    title: "Başkent Millet Bahçesi Sanal Turu",
    description: "Ankara'nın merkezinde bulunan bu millet bahçesi...",
    embed: (
      <iframe
        src="https://www.google.com/maps/embed?pb=!4v1754555978215!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJRGpfcENKU0E.!2m2!1d39.94542426240709!2d32.83933916043877!3f359.10627154669726!4f-12.855229020477893!5f0.7820865974627469"
        className="w-full h-full"
        loading="lazy"
        allow="accelerometer; gyroscope;"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
      />
    ),
    content:
      "Bu alanda Başkent Millet Bahçesi'nin etkileşimli sanal turu yer alacaktır.",
  },
];

const VirtualTourDetailPage = () => {
  const { tourSlug } = useParams();
  const [tour, setTour] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    const foundTour = mockVirtualTours.find(
      (t) => t.slug === tourSlug
    );

    if (foundTour) {
      setTimeout(() => {
        setTour(foundTour);
        setLoading(false);
      }, 800);
    } else {
      setError("Sanal tur bulunamadı.");
      setLoading(false);
    }
  }, [tourSlug]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-900">
        <div className="w-16 h-16 border-4 border-amber-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col justify-center items-center h-screen bg-gray-900 text-red-500">
        <p className="text-xl mb-4">{error}</p>
        <Link
          to="/virtual-tour"
          className="text-indigo-400 hover:underline flex items-center space-x-2"
        >
          <ArrowLeft size={18} />
          <span>Turlara Geri Dön</span>
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <Link
          to="/virtual-tour"
          className="text-gray-400 hover:text-amber-400 flex items-center space-x-2 mb-8"
        >
          <ArrowLeft size={20} />
          <span>Tüm Sanal Turlar</span>
        </Link>

        <header className="text-center mb-12">
          <h1 className="text-5xl font-extrabold bg-gradient-to-r from-teal-400 to-indigo-500 bg-clip-text text-transparent mb-4">
            {tour.title}
          </h1>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto">
            {tour.description}
          </p>
        </header>

        <div className="relative w-full aspect-video bg-gray-800 rounded-2xl shadow-xl overflow-hidden border border-gray-700">
          {tour.embed}
        </div>
      </div>
    </div>
  );
};

export default VirtualTourDetailPage;